import React, { useEffect, useState } from "react";
import './Product.css'
import { ImageTitle } from '../../components/ImageTitle'
import Typography from "@mui/material/Typography";
import { Header } from "../../components/Header";
import { Banner } from "../../components/Banner";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { To, useNavigate } from "react-router-dom";
import { productData, ProductInfo } from '../../data/data';

interface ProductProps {
	imageUrl: string;
	title: string;
	path: string;
}

const defaultProductInfo: ProductInfo = {
	intro: '',
	//summary: '',
	benefits: [
		{ text: '' }
	],
	coverages: [
		{ text: '' }
	],
	assistances: [
		{ text: '' }
	]
};

const Product: React.FC<ProductProps> = ({ imageUrl, title, path }) => {

	const [productInfo, setProductInfo] = useState<ProductInfo>(defaultProductInfo);
	const navigate = useNavigate();
	const handleNavigation = (path: To) => {
		navigate(path);
		window.scrollTo(0, 0);
	};

	useEffect(() => {
		const info = productData[title];
		if (info) {
			setProductInfo(info);
		} else {
			console.error(`No se encontró información para el producto con título: ${title}`);
		}
	}, [title]);

	const highlightText = (text: string) => {
		const colonIndex = text.indexOf(':');
		if (colonIndex !== -1) {
			const boldPart = text.slice(0, colonIndex + 1); // Todo lo antes del ':'
			const remainingText = text.slice(colonIndex + 1); // Todo lo después del ':'
			return (
				<>
					<strong>{boldPart}</strong>
					{remainingText}
				</>
			);
		}
		return text; // Si no hay ':', devuelve el texto tal cual
	};

	return (
		<>
			<Header variant={2} />
			<ImageTitle imageUrl={imageUrl} title={title} path={path} />


			<div className="product-container">

				<div className="head">
					<div className="head-img">
						<img src={imageUrl} alt="Background" className="product-background-image" />
					</div>
					<div className="head-info">
						<Typography
							sx={{
								color: '#272727',
								fontFamily: "Inter, sans-serif",
								fontSize: '16px',
								fontWeight: 400,
							}}
						>
							{productInfo.intro}
						</Typography>
					</div>
				</div>

				<div className="product-info">
					<Typography
						sx={{
							color: '#0033a0',
							fontFamily: "Inter, sans-serif",
							fontSize: '26px',
							fontWeight: 700,
						}}
					>
						Beneficios
					</Typography>

					<div className="separator" />

					<ul className="list">
						{productInfo.benefits.map((benefit, index) => (
							<li key={index}>
								<Typography
									sx={{
										color: '#3b3b3b',
										fontFamily: "Inter, sans-serif",
										fontSize: '16px',
										fontWeight: 400,
									}}
								>
									{highlightText(benefit.text)}
								</Typography>
							</li>
						))}
					</ul>
				</div>

				<div className="product-info">
					<Typography
						sx={{
							color: '#0033a0',
							fontFamily: "Inter, sans-serif",
							fontSize: '26px',
							fontWeight: 700,
						}}
					>
						Coberturas
					</Typography>

					<div className="separator" />

					<ul className="list">
						{productInfo.coverages.map((coverage, index) => (
							<li key={index}>
								<Typography
									sx={{
										color: '#3b3b3b',
										fontFamily: "Inter, sans-serif",
										fontSize: '16px',
										fontWeight: 400,
									}}
								>
									{highlightText(coverage.text)}
								</Typography>
							</li>
						))}
					</ul>

				</div>

				<div className="product-info">
					<Typography
						sx={{
							color: '#0033a0',
							fontFamily: "Inter, sans-serif",
							fontSize: '26px',
							fontWeight: 700,
						}}
					>
						Asistencias
					</Typography>

					<div className="separator" />

					<ul className="list">
						{productInfo.assistances.map((assistance, index) => (
							<li key={index}>
								<Typography
									sx={{
										color: '#3b3b3b',
										fontFamily: "Inter, sans-serif",
										fontSize: '16px',
										fontWeight: 400,
									}}
								>
									{highlightText(assistance.text)}
								</Typography>
							</li>
						))}
					</ul>
				</div>
			</div>


			<Banner title="¿Quieres saber más?" />

			<div className="buttons-container">
				<button className="product-btn green">
					Cotiza
					<WhatsAppIcon style={{ fontSize: '25px', color: 'White', marginLeft: '10px' }} />
				</button>

				<button className="product-btn orange" onClick={() => handleNavigation('/Portafolio')}>
					Portafolio
				</button>
			</div>

		</>
	)
}

export default Product;